var _style, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOurprocess(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 483.4 353.1",
    style: {
      enableBackground: "new 0 0 483.4 353.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F5F5F5;}\n\t.st-font{font-family:'Poppins-Light';}\n\t.st2{font-size:19.0267px;}\n\t.st3{font-size:14.7986px;}\n\t.st4{font-family:'Poppins-Regular';}\n\t.st5{font-size:21.1408px;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M132.6,83.4c-14.9,6.3-24.5,20.9-24.5,37.1v83.1c0,16.2,9.7,30.8,24.6,37.1l70.7,29.9c8,3.4,16.5,5.1,25.3,5.1 c0,0,0,0,0,0l0,0c9,0,17.7-1.8,25.9-5.4l68.9-30c14.7-6.4,24.2-20.9,24.2-37v-83.9c0-16.2-9.6-30.8-24.6-37.1l-68.7-29.2 c-8.1-3.4-16.7-5.1-25.4-5.1c-8.7,0-17.3,1.7-25.4,5.2L132.6,83.4z M229.1,50.4c8.5,0,16.7,1.7,24.4,4.9l68.7,29.2 c14,6,23.1,19.6,23.1,34.9v83.9c0,15.1-8.9,28.7-22.8,34.7l-68.9,30c-7.9,3.4-16.4,5.2-25,5.2c-8.3,0-16.6-1.6-24.3-4.9l-70.7-29.9 c-14.1-5.9-23.1-19.6-23.1-34.9v-83.1c0-15.2,9-28.9,23-34.9l71.1-30.3C212.4,52.1,220.6,50.4,229.1,50.4z"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1.006 0 0 1 71.085 100.4238)",
    className: "st0 st-font st2"
  }, "01"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1.006 0 0 1 366.0039 100.4238)",
    className: "st0 st-font st2"
  }, "03"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1.006 0 0 1 219.3428 16.1724)",
    className: "st0 st-font st2"
  }, "02"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1.006 0 0 1 218.8662 305.1855)",
    className: "st0 st-font st2"
  }, "05"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1.006 0 0 1 24.5273 121.5317)",
    className: "st0 st-font st3"
  }, "Planning"), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1.006 0 0 1 187.7021 170.0957)",
    className: "st0 st4 st5"
  }, "Process")), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1.006 0 0 1 218.8662 35.4141)",
    className: "st0 st-font st3"
  }, "Analysis"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1.006 0 0 1 367.248 121.5317)",
    className: "st0 st-font st3"
  }, "Design"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1.006 0 0 1 71.085 229.2314)",
    className: "st0 st-font st2"
  }, "06"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1.006 0 0 1 366.0039 229.2314)",
    className: "st0 st-font st2"
  }, "04"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1.006 0 0 1 0 251.7422)",
    className: "st0 st-font st3"
  }, "Maintenance"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1.006 0 0 1 367.248 251.7422)",
    className: "st0 st-font st3"
  }, "Implementation"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1.006 0 0 1 219.3428 327.8779)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    className: "st0 st-font st3"
  }, "Testing &"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 16.9,
    className: "st0 st-font st3"
  }, "Integration")))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOurprocess);
export default __webpack_public_path__ + "static/media/Our process.68697ff2.svg";
export { ForwardRef as ReactComponent };